import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import OfferteConfigurator from "./sections/OfferteConfigurator";
import TrustedByLeaders from "./sections/TrustedByLeaders";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <OfferteConfigurator />
      <TrustedByLeaders />
      <Footer />
    </div>;
}